const loadImage = (url) => {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.onload = () => {
			img.decode()
				.then(() => {
					resolve(img);
				})
				.catch(err => {
					reject(err);
				})
			;
		}
		img.onerror = () => {
			reject(new Error('Image failed to load'));
		};
		img.src = url ?? '';
	});
};

export default loadImage;